import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export default function useBrn(form: any, updateFormValues: any) {
  const [brnError, setBrnError] = useState<any>(null);
  const [brnUser, setBrnUser] = useState<any>(null);
  const [loader, setLoader] = useState<any>(false);
  const [success, setSuccess] = useState<any>(false);

  useEffect(() => {
    setBrnError(null);
    if (form?.brn) {
      if (form?.brn?.length == 14) {
        setLoader(true);
        setSuccess(false);
        setBrnUser(null);
        const fetchBrn = async () => {
          try {
            // const BRN_SERVICE_URL = `http://service.test.iras.go.ug/ura/services/validate_brn`;
            const BRN_SERVICE_URL =
              "https://eservices.nema.go.ug/api/services/validate-brn/";

            const response: any = await axios.get(BRN_SERVICE_URL, {
              headers: {
                "Content-Type": "application/json",
              },
              params: {
                brn: form?.brn,
              },
            });
            setLoader(false);

            // Check if response has valid data with entityName
            if (response?.data && response.data.entityName) {
              setBrnUser(response?.data);
            } else {
              // Response received but no valid data found
              setBrnUser(null);
              setSuccess(false);
              toast.error("BRN data not found");
              updateFormValues({
                legal_name: "",
                business_name: "",
              });
            }
          } catch (error) {
            setLoader(false);
            setSuccess(false);
            toast.error("BRN data not found");
            updateFormValues({
              legal_name: "",
              business_name: "",
            });
          }
        };
        fetchBrn();
      } else {
        setLoader(false);
        setSuccess(false);
        updateFormValues({
          legal_name: "",
          business_name: "",
        });
      }
    }
  }, [form?.brn]);

  useEffect(() => {
    if (brnUser) {
      updateFormValues({
        legal_name: brnUser?.entityName,
        business_name: brnUser?.entityName,
      });
      setBrnError(null);
      // Set success to true only after values are updated
      setSuccess(true);
    }
    // Don't set error here - it's handled in the API call itself
  }, [brnUser]);

  return { loader, brnError, success };
}
